import { render, staticRenderFns } from "./air-num.vue?vue&type=template&id=cbddb34e&scoped=true&"
import script from "./air-num.vue?vue&type=script&lang=js&"
export * from "./air-num.vue?vue&type=script&lang=js&"
import style0 from "./air-num.vue?vue&type=style&index=0&id=cbddb34e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbddb34e",
  null
  
)

export default component.exports